import { render, staticRenderFns } from "./TheApprovalOrdersTable.vue?vue&type=template&id=1516adf0&scoped=true"
import script from "./TheApprovalOrdersTable.vue?vue&type=script&lang=js"
export * from "./TheApprovalOrdersTable.vue?vue&type=script&lang=js"
import style0 from "./TheApprovalOrdersTable.vue?vue&type=style&index=0&id=1516adf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1516adf0",
  null
  
)

export default component.exports